import React, { useState, useEffect, useContext } from "react";
import {
  Box,
  Grid,
  Paper,
  Typography,
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  InputAdornment,
  Modal,
  Backdrop,
  Fade,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import { AppContext } from "../../context/AppContext";
import SidebarMenu from "./AdminPanel/SidebarMenu";
import TopBar from "./AdminPanel/TopBar";
import { useNavigate } from "react-router-dom";

const AdminSection = ({ setSelectedComponent }) => {
  const navigate = useNavigate();
  const { sections, brands } = useContext(AppContext);
  const [open, setOpen] = useState(false);
  const [submenuOpen, setSubmenuOpen] = useState(false);

  const [searchTermSections, setSearchTermSections] = useState("");
  const [filteredSections, setFilteredSections] = useState([]);
  const [pageSections, setPageSections] = useState(0);
  const [rowsPerPageSections, setRowsPerPageSections] = useState(10);

  const [searchTermBrands, setSearchTermBrands] = useState("");
  const [filteredBrands, setFilteredBrands] = useState([]);
  const [pageBrands, setPageBrands] = useState(0);
  const [rowsPerPageBrands, setRowsPerPageBrands] = useState(10);

  const [openImageModal, setOpenImageModal] = useState(false);
  const [modalImageUrl, setModalImageUrl] = useState("");

  const formatSections = (sectionsList) =>
    sectionsList.map((section) => ({
      id: section.id,
      name: section.name,
      image: section.image || null,
      categories: (section.categories || []).map((cat) => cat.name),
    }));

  useEffect(() => {
    const formattedSections = formatSections(sections);
    setFilteredSections(
      formattedSections.filter(
        (section) =>
          section.name.toLowerCase().includes(searchTermSections.toLowerCase()) ||
          section.categories.join(" ").toLowerCase().includes(searchTermSections.toLowerCase())
      )
    );
    setPageSections(0);
  }, [sections, searchTermSections]);

  useEffect(() => {
    setFilteredBrands(
      brands.filter((brand) =>
        brand.name.toLowerCase().includes(searchTermBrands.toLowerCase())
      )
    );
    setPageBrands(0);
  }, [brands, searchTermBrands]);

  const handleChangePageSections = (event, newPage) => setPageSections(newPage);
  const handleChangeRowsPerPageSections = (event) => {
    setRowsPerPageSections(parseInt(event.target.value, 10));
    setPageSections(0);
  };
  const handleChangePageBrands = (event, newPage) => setPageBrands(newPage);
  const handleChangeRowsPerPageBrands = (event) => {
    setRowsPerPageBrands(parseInt(event.target.value, 10));
    setPageBrands(0);
  };

  const handleOpenImageModal = (url) => {
    setModalImageUrl(url);
    setOpenImageModal(true);
  };
  const handleCloseImageModal = () => {
    setOpenImageModal(false);
    setModalImageUrl("");
  };

  const handleLogout = async () => {
    try {
      await fetch("/sistema/logout/", { method: "POST", credentials: "include" });
    } catch {}
    localStorage.clear();
    navigate("/login");
  };

  const handleSelect = (component) => {
    if (component === "AdminSection") navigate("/admin-panel/secciones");
    else if (component === "ModalInventario") setSubmenuOpen((s) => !s);
    else if (component === "AdminProduct") navigate("/admin-panel/inventario/productos");
    else if (component === "AdminVariant") navigate("/admin-panel/inventario/variantes");
    else if (component === "AdminProforma") navigate("/admin-panel/proformas");
    else if (component === "AdminClient") navigate("/admin-panel/clientes");
    else if (component === "AdminServices") navigate("/admin-panel/servicios");
    else if (component === "AdminPromotion") navigate("/admin-panel/promociones");
    else navigate("/admin-panel");
  };

  return (
    <Box sx={{ display: "flex", minHeight: "100vh", bgcolor: "#f5f6fa" }}>
      <SidebarMenu
        open={open}
        setOpen={setOpen}
        submenuOpen={submenuOpen}
        setSubmenuOpen={setSubmenuOpen}
        navigate={navigate}
        handleLogout={handleLogout}
      />
      <Box sx={{ flexGrow: 1 }}>
        <TopBar open={open} setOpen={setOpen} />
        <Box sx={{ width: "95%", mx: "auto", mt: 3, mb: 3 }}>
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={() => navigate("/admin-panel/secciones/nueva")}
            sx={{
              textTransform: "none",
              bgcolor: "#1565C0",
              "&:hover": { bgcolor: "#0D47A1" },
              mb: 3,
            }}
          >
            Administrar
          </Button>

          <Grid container spacing={4}>
            <Grid item xs={12} md={8}>
              <Paper
                sx={{
                  p: 3,
                  borderRadius: "12px",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                  bgcolor: "#FFFFFF",
                }}
              >
                <Typography variant="h6" gutterBottom>
                  Secciones y Categorías
                </Typography>
                <TextField
                  label="Buscar secciones y categorías"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  value={searchTermSections}
                  onChange={(e) => setSearchTermSections(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon color="action" />
                      </InputAdornment>
                    ),
                  }}
                />
                <TableContainer sx={{ maxHeight: 400 }}>
                  <Table stickyHeader size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell align="center" sx={{ backgroundColor: "#1565C0", color: "#FFFFFF" }}>
                          Imagen
                        </TableCell>
                        <TableCell sx={{ backgroundColor: "#1565C0", color: "#FFFFFF" }}>
                          Sección
                        </TableCell>
                        <TableCell sx={{ backgroundColor: "#1565C0", color: "#FFFFFF" }}>
                          Categorías
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {filteredSections
                        .slice(
                          pageSections * rowsPerPageSections,
                          pageSections * rowsPerPageSections + rowsPerPageSections
                        )
                        .map((section) => (
                          <TableRow key={section.id}>
                            <TableCell align="center">
                              {section.image ? (
                                <Button variant="text" onClick={() => handleOpenImageModal(section.image)}>
                                  Ver imagen
                                </Button>
                              ) : (
                                "-"
                              )}
                            </TableCell>
                            <TableCell>{section.name}</TableCell>
                            <TableCell>
                              {section.categories.length > 0
                                ? section.categories.join(", ")
                                : "Sin categorías"}
                            </TableCell>
                          </TableRow>
                        ))}
                    </TableBody>
                  </Table>
                </TableContainer>
                <TablePagination
                  sx={{
                    "& .MuiTablePagination-caption": { fontSize: "0.8rem" },
                    "& .MuiTablePagination-selectLabel": { fontSize: "0.8rem" },
                    "& .MuiTablePagination-select": { fontSize: "0.8rem" },
                  }}
                  component="div"
                  count={filteredSections.length}
                  page={pageSections}
                  onPageChange={handleChangePageSections}
                  rowsPerPage={rowsPerPageSections}
                  onRowsPerPageChange={handleChangeRowsPerPageSections}
                  labelRowsPerPage="Filas por página:"
                  labelDisplayedRows={({ from, to, count }) =>
                    `${from}-${to} de ${count !== -1 ? count : `más de ${to}`}`
                  }
                  rowsPerPageOptions={[5, 10, 25]}
                />
              </Paper>
            </Grid>

            <Grid item xs={12} md={4}>
              <Paper
                sx={{
                  p: 3,
                  borderRadius: "12px",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                  bgcolor: "#FFFFFF",
                }}
              >
                <Typography variant="h6" gutterBottom>
                  Marcas
                </Typography>
                <TextField
                  label="Buscar marcas"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  value={searchTermBrands}
                  onChange={(e) => setSearchTermBrands(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon color="action" />
                      </InputAdornment>
                    ),
                  }}
                />
                <TableContainer sx={{ maxHeight: 400 }}>
                  <Table stickyHeader size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{ backgroundColor: "#1565C0", color: "#FFFFFF" }}>
                          Nombre
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {filteredBrands
                        .slice(
                          pageBrands * rowsPerPageBrands,
                          pageBrands * rowsPerPageBrands + rowsPerPageBrands
                        )
                        .map((brand) => (
                          <TableRow key={brand.id}>
                            <TableCell>{brand.name}</TableCell>
                          </TableRow>
                        ))}
                    </TableBody>
                  </Table>
                </TableContainer>
                <TablePagination
                  sx={{
                    "& .MuiTablePagination-caption": { fontSize: "0.8rem" },
                    "& .MuiTablePagination-selectLabel": { fontSize: "0.8rem" },
                    "& .MuiTablePagination-select": { fontSize: "0.8rem" },
                  }}
                  component="div"
                  count={filteredBrands.length}
                  page={pageBrands}
                  onPageChange={handleChangePageBrands}
                  rowsPerPage={rowsPerPageBrands}
                  onRowsPerPageChange={handleChangeRowsPerPageBrands}
                  labelRowsPerPage="Filas por página:"
                  labelDisplayedRows={({ from, to, count }) =>
                    `${from}-${to} de ${count !== -1 ? count : `más de ${to}`}`
                  }
                  rowsPerPageOptions={[5, 10, 25]}
                />
              </Paper>
            </Grid>
          </Grid>

          <Modal
            open={openImageModal}
            onClose={handleCloseImageModal}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{ timeout: 500 }}
          >
            <Fade in={openImageModal}>
              <Box
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  bgcolor: "background.paper",
                  boxShadow: 24,
                  p: 2,
                  maxWidth: "90%",
                  maxHeight: "90%",
                }}
              >
                <img
                  src={modalImageUrl}
                  alt="Sección"
                  style={{ width: "100%", height: "auto", display: "block" }}
                />
              </Box>
            </Fade>
          </Modal>
        </Box>
      </Box>
    </Box>
  );
};

export default AdminSection;
